import { render } from "./IncludeSections.vue?vue&type=template&id=1de57710&scoped=true"
import script from "./IncludeSections.vue?vue&type=script&lang=js"
export * from "./IncludeSections.vue?vue&type=script&lang=js"

import "./IncludeSections.vue?vue&type=style&index=0&id=1de57710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de57710"]])

export default __exports__